import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ScrollToTop } from './components/shared/ScrollToTop'
import { ErrorBoundary } from './components/shared/ErrorBoundary'
import { createErrorHandler } from './lib/error-reporting'
import { SignInPage } from './modules/auth/SignInPage'
import { ProtectedRoute } from './components/shared/ProtectedRoute'
import { DashboardLayout } from './layouts/DashboardLayout'
import { DashboardPage } from './pages/DashboardPage'
import { RootRedirect } from './pages/RootRedirect'
import { SettingsPage } from './modules/settings/pages/SettingsPage'
import { PluginsPage } from './modules/plugins/pages/PluginsPage'
import { PluginDetailPage } from './modules/plugins/pages/PluginDetailPage'
import { ThemesPage } from './modules/themes/pages/ThemesPage'
import { ThemeDetailPage } from './modules/themes/pages/ThemeDetailPage'
import { LicensesPage } from './modules/licenses/pages/LicensesPage'
import { SitesPage } from './modules/sites/pages/SitesPage'
import { SiteDetailPage } from './modules/sites/pages/SiteDetailPage'
import { SitesRegistryPage } from './modules/sites-registry/pages/SitesRegistryPage'
import { LogsPage } from './modules/logs/pages/LogsPage'

function App() {
  return (
    <ErrorBoundary onError={createErrorHandler()}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Root redirect - sends to /dashboard or /sign-in based on auth */}
          <Route path="/" element={<RootRedirect />} />

          {/* Auth routes (Google OAuth only) */}
          <Route path="/sign-in" element={<SignInPage />} />

          {/* Legacy email/password routes redirect to sign-in */}
          <Route path="/sign-up" element={<Navigate to="/sign-in" replace />} />
          <Route path="/forgot-password" element={<Navigate to="/sign-in" replace />} />
          <Route path="/reset-password" element={<Navigate to="/sign-in" replace />} />

          {/* Protected dashboard routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            {/* Dashboard index page */}
            <Route index element={<DashboardPage />} />

            {/* Plugins management */}
            <Route path="plugins" element={<PluginsPage />} />
            <Route path="plugins/:slug" element={<PluginDetailPage />} />

            {/* Themes management */}
            <Route path="themes" element={<ThemesPage />} />
            <Route path="themes/:slug" element={<ThemeDetailPage />} />

            {/* Licenses management */}
            <Route path="licenses" element={<LicensesPage />} />

            {/* Universal Sites Registry */}
            <Route path="sites" element={<SitesRegistryPage />} />

            {/* JezPress OAuth management (renamed from sites) */}
            <Route path="jezpress" element={<SitesPage />} />
            <Route path="jezpress/:domain" element={<SiteDetailPage />} />


            {/* Auth events (login history and monitoring) */}
            <Route path="logs" element={<LogsPage />} />
            <Route path="auth-events" element={<Navigate to="/dashboard/logs?tab=auth" replace />} />

            {/* Activity Logs (centralized logging) */}
            <Route path="activity-logs" element={<Navigate to="/dashboard/logs?tab=activity" replace />} />

            {/* Settings module - profile, theme, etc. */}
            <Route path="settings" element={<SettingsPage />} />

            {/* Profile redirects to Settings (Profile tab is default) */}
            <Route path="profile" element={<Navigate to="/dashboard/settings" replace />} />


          </Route>

          {/* Catch all - redirect to root (which handles auth check) */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

export default App
